import usePipelineStatusTranslations from "../../hooks/usePipelineStatusTranslations";

export default function PipelineStatus({ distribution }) {
	const translations = usePipelineStatusTranslations();

	return translations[distribution.status] || null;
}
